import { render } from "./player.vue?vue&type=template&id=4f4d0c7e&scoped=true"
import script from "./player.vue?vue&type=script&lang=js"
export * from "./player.vue?vue&type=script&lang=js"

import "./player.vue?vue&type=style&index=0&id=4f4d0c7e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4f4d0c7e"

export default script